import Link from '@/components/Link';
import NewLabel from '@/components/NewLabel';

import { IMenuItem } from '@/helpers/interfaces/common.interface';

import styles from './submenu-list.module.css';

interface SubmenuListProps {
  onClickItem?: () => void,
  items: (IMenuItem & { isNew?: boolean })[]
}

const SubmenuList = ({ onClickItem, items }: SubmenuListProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.items}>
        {items.map(({ name, href, isNew }) => (
          <Link className={styles.item} href={href} onClick={onClickItem} key={name}>
            {name} {isNew && <NewLabel />}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SubmenuList;
